var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-assigner"},[_c('volunteers-selector',{attrs:{"btn-label":"حفظ التغيرات"},on:{"onSubmit":_vm.onPublishCourse}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }